/** API `invalid_fields` key → Formik field name. Modeled on
 *  `common/features/profile/player/beFieldMap.ts` — the address sub-object
 *  always arrives dotted, so only the dotted spelling is mapped. */
export const EVENT_BE_FIELD_MAP: Record<string, string> = {
  name: 'name',
  category: 'category',
  // The wire name is `details`; the Formik field is still `description`.
  // `description` stays mapped in case an older error payload uses it.
  details: 'description',
  description: 'description',
  starts_at: 'starts_at',
  ends_at: 'ends_at',
  timezone: 'timezone',
  arrival_time_minutes: 'arrivalTimeMinutes',
  recurrence_type: 'recurrenceType',
  days_of_week: 'daysOfWeek',
  repeat_until: 'repeatUntil',
  'address.street_1': 'addressStreet1',
  'address.street_2': 'addressStreet2',
  'address.city': 'addressCity',
  'address.postal_code': 'addressPostalCode',
  'address.country_id': 'addressCountryId',
  'address.province_id': 'addressProvinceId',
}
